<app-error-page-layout>
  <div
    class="bg-accent-orange-subtle mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full">
    <i class="ph-bold ph-wifi-slash text-accent-orange text-4xl"></i>
  </div>

  <h1 class="mb-2">{{ 'error_pages.api_down.title' | translate }}</h1>
  <p class="text-text-secondary mb-2">
    {{ 'error_pages.api_down.description' | translate }}
  </p>
  <p class="text-text-tertiary mb-8 text-sm">
    {{ 'error_pages.api_down.information' | translate }}
  </p>

  <button
    onclick="window.location.href = '/'"
    class="btn-primary inline-flex items-center justify-center gap-2 rounded-sm px-5 py-2.5 text-sm">
    <i class="ph-bold ph-arrows-clockwise"></i>
    {{ 'error_pages.api_down.retry' | translate }}
  </button>
</app-error-page-layout>
